import { render, staticRenderFns } from "./ViewClaims.vue?vue&type=template&id=4c92b34a&"
import script from "./ViewClaims.vue?vue&type=script&lang=js&"
export * from "./ViewClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports